import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Button, Drawer } from "../../themeV2";
import CartGrouping from "./CartGrouping";
import Totals from "./Totals";
import css from "./ShoppingCart.module.css";

function Groups({ children }) {
  return <div className={css.groups}>{children}</div>;
}

Groups.propTypes = { children: PropTypes.node };

export default function ShoppingCart({ onClose, cart }) {
  const history = useHistory();
  const isEmpty = cart.cartProducts.length === 0;

  const goToCheckout = () => {
    onClose();
    history.push("/checkout");
  };

  return (
    <Drawer.Root
      open
      side="right"
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <Drawer.Popup size="lg" className={css.popup}>
        <Drawer.Header>
          <Drawer.Title>Shopping cart</Drawer.Title>
          <Drawer.Close />
        </Drawer.Header>

        <Drawer.Body>
          <CartGrouping
            shipmentGroups={cart.shipmentGroups}
            cartProducts={cart.cartProducts}
            canEdit
            groupPadding={0}
            Container={Groups}
          />
        </Drawer.Body>

        <Drawer.Actions className={css.footer}>
          {!isEmpty && <Totals />}

          <div className={css.buttons}>
            <Button
              variant="outlined"
              size="lg"
              className={css.continue}
              onClick={onClose}
            >
              Continue shopping
            </Button>
            <Button size="lg" onClick={goToCheckout} disabled={isEmpty}>
              Go to checkout
            </Button>
          </div>
        </Drawer.Actions>
      </Drawer.Popup>
    </Drawer.Root>
  );
}

ShoppingCart.propTypes = {
  cart: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
